<template>
  <div>
    {{$companyConfiguration.settings.getEnum('card_types')[row.info.type]}}
  </div>
</template>

<script>

export default {
  name: "card-type-column-template",
  props: {
    row: {type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {}
}
</script>

<style></style>
